<script setup>
const props = defineProps({
  className: {
    type: String,
    default: undefined,
  },
});

const documentScrollTop = ref(0);

const isHeaderFixed = computed(() => {
  return documentScrollTop.value > 0;
});

onMounted(() => {
  documentScrollTop.value = document.documentElement.scrollTop;
  document.addEventListener('scroll', onBodyScroll);
});

function onBodyScroll() {
  documentScrollTop.value = document.documentElement.scrollTop;
}
</script>

<template>
  <div class="layouts-default" :class="className">
    <LayoutWrapper class="layouts-default" :class="props.className">
      <LayoutHeader :is-fixed="isHeaderFixed" class="layouts-default__header" />

      <slot class-name="layouts-default__view" />

      <LayoutFooter />
    </LayoutWrapper>
  </div>
</template>

<style scoped lang="scss">
.layouts-default {
  $parent: &;

  display: flex;
  flex-direction: column;

  &:deep(#{$parent}__view) {
    flex-grow: 1;
  }

  &__header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 5;
  }
}
</style>
